/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReceiptFilterQueryDto
 */
export interface ReceiptFilterQueryDto {
    /**
     * Filter by bank account numbers
     * @type {Array<string>}
     * @memberof ReceiptFilterQueryDto
     */
    bankAccountNumbers?: Array<string>;
    /**
     * Filter by source broker IDs
     * @type {Array<string>}
     * @memberof ReceiptFilterQueryDto
     */
    sourceBrokerIds?: Array<string>;
    /**
     * Filter by currencies
     * @type {Array<string>}
     * @memberof ReceiptFilterQueryDto
     */
    currencies?: Array<string>;
    /**
     * Filter by transaction date from
     * @type {Date}
     * @memberof ReceiptFilterQueryDto
     */
    transactionDateFrom?: Date;
    /**
     * Filter by transaction date to
     * @type {Date}
     * @memberof ReceiptFilterQueryDto
     */
    transactionDateTo?: Date;
    /**
     * Include source broker in response
     * @type {boolean}
     * @memberof ReceiptFilterQueryDto
     */
    includeSourceBroker?: boolean;
    /**
     * Include bank account in response
     * @type {boolean}
     * @memberof ReceiptFilterQueryDto
     */
    includeBankAccount?: boolean;
    /**
     * Include files in response
     * @type {boolean}
     * @memberof ReceiptFilterQueryDto
     */
    includeFiles?: boolean;
}

/**
 * Check if a given object implements the ReceiptFilterQueryDto interface.
 */
export function instanceOfReceiptFilterQueryDto(value: object): value is ReceiptFilterQueryDto {
    return true;
}

export function ReceiptFilterQueryDtoFromJSON(json: any): ReceiptFilterQueryDto {
    return ReceiptFilterQueryDtoFromJSONTyped(json, false);
}

export function ReceiptFilterQueryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReceiptFilterQueryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'bankAccountNumbers': json['bankAccountNumbers'] == null ? undefined : json['bankAccountNumbers'],
        'sourceBrokerIds': json['sourceBrokerIds'] == null ? undefined : json['sourceBrokerIds'],
        'currencies': json['currencies'] == null ? undefined : json['currencies'],
        'transactionDateFrom': json['transactionDateFrom'] == null ? undefined : (new Date(json['transactionDateFrom'])),
        'transactionDateTo': json['transactionDateTo'] == null ? undefined : (new Date(json['transactionDateTo'])),
        'includeSourceBroker': json['includeSourceBroker'] == null ? undefined : json['includeSourceBroker'],
        'includeBankAccount': json['includeBankAccount'] == null ? undefined : json['includeBankAccount'],
        'includeFiles': json['includeFiles'] == null ? undefined : json['includeFiles'],
    };
}

export function ReceiptFilterQueryDtoToJSON(json: any): ReceiptFilterQueryDto {
    return ReceiptFilterQueryDtoToJSONTyped(json, false);
}

export function ReceiptFilterQueryDtoToJSONTyped(value?: ReceiptFilterQueryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'bankAccountNumbers': value['bankAccountNumbers'],
        'sourceBrokerIds': value['sourceBrokerIds'],
        'currencies': value['currencies'],
        'transactionDateFrom': value['transactionDateFrom'] == null ? undefined : ((value['transactionDateFrom']).toISOString()),
        'transactionDateTo': value['transactionDateTo'] == null ? undefined : ((value['transactionDateTo']).toISOString()),
        'includeSourceBroker': value['includeSourceBroker'],
        'includeBankAccount': value['includeBankAccount'],
        'includeFiles': value['includeFiles'],
    };
}

